export enum InputCustomTypeEnum {
  Currency = 'currency',
  Percentage = 'percentage',
  Telephone = 'tel'
}
